import React, { useContext } from 'react';
import { Query } from 'react-apollo';
import DirectDebitLogo from './DirectDebitLogo';
import SepaLogo from './SepaLogo';
import BBBLogo from './BBBLogo';
import TrustedShop from './TrustedShop';
import trusteSealsQuery from './TrusteSeals.graphql';
import './truste-seals.scss';
import { SMFooterContext } from '../SMFooterContext';

const showTrustedShopSeal = (lang, country) => {
  if (['DE', 'AT', 'CH'].includes(country) && lang === 'de') {
    return true;
  }
  return false;
};

const showFooterSeals = () => {
  return (
    <Query query={trusteSealsQuery}>
      {({ loading, error, data }) => {
        if (loading) return null;
        if (error) return null;
        const recentInvoice =
          (data &&
            data.user &&
            data.user.team &&
            data.user.team.billing &&
            data.user.team.billing.recentInvoice) ||
          {};
        const { paymentMethod, paymentMethodSubtype } = recentInvoice;
        return (
          paymentMethod === 'DIRECT_DEBIT' && (
            <Choose>
              <When condition={paymentMethodSubtype === 'GOCARDLESS_SEPA_DD'}>
                <span className="wds-flex__item  wds-m-2">
                  <SepaLogo />
                </span>
              </When>
              <Otherwise>
                <span className="wds-flex__item  wds-m-2">
                  <DirectDebitLogo />
                </span>
              </Otherwise>
            </Choose>
          )
        );
      }}
    </Query>
  );
};

const TrusteSeals = () => {
  const { lang, country, isUserAuthenticated, isEUDC } = useContext(
    SMFooterContext
  );
  let McAfeeHost = 'www.surveymonkey.com';
  if (isEUDC) {
    McAfeeHost = 'eu.surveymonkey.com';
  }
  return (
    <>
      <a
        className="wds-flex__item  wds-m-2"
        title="Click to verify BBB accreditation and to see a BBB report."
        href="https://www.bbb.org/us/ca/san-mateo/profile/market-survey/surveymonkey-1116-876628"
        rel="noopener noreferrer"
        target="_blank"
      >
        <BBBLogo />
      </a>
      <a
        className="wds-flex__item  wds-m-2"
        title="McAfee SECURE sites help keep you safe from identity theft, credit card fraud, spyware, spam, viruses and online scams"
        href={`https://www.mcafeesecure.com/verify?host=${McAfeeHost}`}
        rel="noopener noreferrer"
        target="_blank"
      >
        <img
          className="sm-truste-seals__img"
          alt="McAfee SECURE sites help keep you safe from identity theft, credit card fraud, spyware, spam, viruses and online scams"
          src="https://cdn.smassets.net/assets/cms/cc/app/static/mcafee.gif"
        />
      </a>
      {isUserAuthenticated && showFooterSeals()}
      {showTrustedShopSeal(lang, country) && <TrustedShop />}
    </>
  );
};

export default TrusteSeals;
